





















































































































import {Component, PropSync, Watch} from 'vue-property-decorator'
  import {Getter, Action} from "vuex-class";
  import BaseFilter from "@/components/Filter/BaseFilter";
  import {AccountFilter} from "@/store/settings/accounts/types";
  import {SelectWings, ToggleWings} from "wings-ui-components";
  import {notifyError} from "@/utils/notify-helper";
  import {getTranslatedParams} from "@/utils/notify-utils";

  @Component({components: {SelectWings, ToggleWings}})
  export default class AccountsFilter extends BaseFilter<AccountFilter>{
    @PropSync('filterProp') filterParent!: any;
    @PropSync('runFilter') run!: any;
    @PropSync('show') is_show!: boolean;

    @Getter("transports") transportsList: any;
    @Getter("protocolList") protocolList: any;

    @Action("getPartners") actionGetPartners: any;
    @Action("getTransports") actionGetTransports: any;
    @Action("getAccounts") actionGetAccounts: any;
    @Action("exportAccounts") actionExportAccounts: any;

    defaultFilter(): AccountFilter {
      return {
        name: undefined,
        login: undefined,
        partner: undefined,
        protocol: undefined,
        transport: undefined,
        status: undefined,
        page_number: 1
      }
    }

    loginList: any = []
    nameList: any = []
    statusList:number[] = [1,0];
    partnersList: any = []

    filterKeys: object = {
      "name" : "account_name",
      "login" : "account_login",
    }

    async getNameList(filter: any) {
      const items = await this.actionGetAccounts(filter);
      this.nameList = (filter?.page_number > 1) ? this.nameList.concat(items) : items
    }

    async getLoginList(filter: any) {
      const items = await this.actionGetAccounts(filter);
      this.loginList = (filter?.page_number > 1) ? this.loginList.concat(items) : items
    }

    async getPartnersList(filter: any) {
      const items = await this.actionGetPartners(filter);
      this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
    }

    async created() {
      this.actionGetTransports();
      this.filtered();
      this.scroll();
      if (this.filter.name) this.nameList = await this.actionGetAccounts({name: this.filter.name});
      if (this.filter.login) this.loginList = await this.actionGetAccounts({login: this.filter.login});
      if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    }

    export(): void {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Export",
        action_status: "success",
        object_type: "Account",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      }
      this.actionExportAccounts(this.filter).then(()=>{
        this.actionLog(this.logObject);
      }).catch((error: any) =>{
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error)
      })
    }

    async onFilteredAction(nextPage = false) {
      if (!nextPage) this.filter.page_number = 1;
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Account",
          addititional_info: getTranslatedParams(this.filter, this.filterKeys)
        };
        const resp = await this.actionGetAccounts(this.filter);
        await this.actionLog(this.logObject);
        this.is_last = resp.length == 0;
      } catch (err) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(err);
      } finally {
        this.moreLoading = false;
      }
    }

    @Watch('filter', {immediate: true, deep: true})
    onFilterChanged(val: AccountFilter) {
      this.filterParent = val;
    }

    @Watch('run')
    onRunFilter(val: boolean) {
      if (!val) return;
      this.filtered();
      this.run = false;
    }
  }
